import React, { StatelessComponent } from 'react';
import b from 'b_';

import './news.stub.css';

import { BreadcrumbsStub } from '@components/breadcrumbs';
import Rect from '@components/rect';

const class_ = b.with('news-page-stub');

const NewsPageStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <BreadcrumbsStub />

            <Rect
                type="black"
                className={class_('image')}
            />
            <Rect height={48} type="black" />
            <Rect width={100} height={28} />

            <div className={class_('content')}>
                <Rect height={20} />
                <Rect height={20} />
                <Rect height={20} />
                <Rect height={20} />
                <Rect height={20} />
                <Rect height={20} />
            </div>
            <Rect height={20} />
            <Rect width={200} height={48} />
        </div>
    );
};

export default NewsPageStub;
